"use strict";
/*
 * Created on 17. 7. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * This is common-be-fe equivalent of YDGOptResultOptimalMargin independent on yieldigo-client module.
 * @author Radek Beran
 */


var OptimalMarginGraphData =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(OptimalMarginGraphData, _DomainObject_1$Domai);

  function OptimalMarginGraphData(optimizationGoal, margin) {
    var _this;

    _classCallCheck(this, OptimalMarginGraphData);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptimalMarginGraphData).call(this));
    _this.optimizationGoal = optimizationGoal;
    _this.margin = margin;
    return _this;
  }

  return OptimalMarginGraphData;
}(DomainObject_1.DomainObject);

exports.OptimalMarginGraphData = OptimalMarginGraphData;

OptimalMarginGraphData.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(OptimalMarginGraphData.name);
  return {
    optimizationGoal: builder.str('optimizationGoal'),
    margin: builder.num('margin')
  };
}();